import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { map, of, pipe, switchMap } from 'rxjs';

// AngularFire AuthGuard Services
import { AngularFireAuthGuard, customClaims } from '@angular/fire/compat/auth-guard';

const checkCustomToken = (data: any) => {
  return new Promise((resolve) => {
    if (!data.queryParams.customToken) resolve(redirectTo(data));
    signInWithCustomToken(getAuth(), data.queryParams.customToken)
      .then((_) => {
        resolve(true);
      })
      .catch((_) => {
        resolve(redirectTo(data));
      });
  });
};

const redirectTo = (data: any) =>
  data.queryParams && !!data.queryParams.identifier ? ['auth/login', { redirectTo: data['_routerState']['url'] }] : 'auth/login';

const hasCustomToken = (data: any) => {
  return pipe(
    customClaims,
    switchMap((claims) => {
      if (claims.tenant) return of(true);
      return checkCustomToken(data);
      // TO implement alternative return iif((claims) => !!claims.tenant, of(true), of(checkCustomToken(data)));
    }),
    map((result) => {
      return result;
    })
  );
};

const redirectLoggedInToHome = () =>
  pipe(
    customClaims,
    map((claims) => (claims.tenant ? ['pages'] : true))
  );

const routes: Routes = [
  // redirect without the / to keep query params after redirect
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  {
    path: 'auth',
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: redirectLoggedInToHome },
    loadChildren: () => import('@noovle/auth').then((m) => m.AuthModule),
  },
  {
    path: 'pages',
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: hasCustomToken, isPublic: false },
    loadChildren: () => import('./page-viewer/page-viewer.module').then((m) => m.PageViewerModule),
  },
  {
    path: 'public/pages',
    data: { isPublic: true },
    loadChildren: () => import('./page-viewer/page-viewer.module').then((m) => m.PageViewerModule),
  },
  {
    path: 'dashboard',
    canActivate: [AngularFireAuthGuard],
    data: { authGuardPipe: hasCustomToken, isPublic: false },
    loadChildren: () => import('./page-viewer/page-viewer.module').then((m) => m.PageViewerModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
